import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { productDetail } from '@/features/product/api'
import { RecipeProductForm } from '@/features/recipe/components/recipe-form'

export const Route = createFileRoute('/_app/product/$id/recipe')({
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()
	const { product } = useSuspenseQuery(productDetail.qry({ id })).data

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/product', 'Product'],
					['/inventory/master', product.name],
					[Route.fullPath, 'Resep Produk'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Resep Produk" />
				<RecipeProductForm />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
